import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, Grid, Paper, Typography} from "@mui/material";
import {shelf, shelf_recalculate_prices} from "./Shelf";
import { Stage, Layer, Rect, Circle } from 'react-konva';
import {nanoid} from "nanoid";

// Parameters of warehouse
const max_shelf_size = 20;
const max_item_types = 16;
const warehouse_x = 6;
const warehouse_y = 2;
const move_time = 200;
const colors = [
    '#1f77b4', // Modrá
    '#ff7f0e', // Oranžová
    '#2ca02c', // Zelená
    '#d62728', // Červená
    '#9467bd', // Fialová
    '#8c564b', // Hnědá
    '#e377c2', // Růžová
    '#7f7f7f', // Šedá
    '#bcbd22', // Olivová
    '#17becf', // Azurová
    '#aec7e8', // Světle modrá
    '#ffbb78', // Svetlá oranžová
    '#98df8a', // Světle zelená
    '#ff9896', // Svetlá červená
    '#c5b0d5', // Svetlá fialová
    '#c49c94'  // Svetlá hnědá
];

let warehouse;

const create_empty_warehouse = () => {
    console.log("create_empty_warehouse");
    const warehouse_size = warehouse_x * warehouse_y;
    const warehouse = [];
    for (let i = 0; i < warehouse_size; i++) {
        warehouse.push([]); // Shelf
    }
    return warehouse;
}

const draw_warehouse_basic = () => {
    console.log("draw warehouse basic");
    const ret = [];
    for (let i=0; i < warehouse_x; i++) {
        for (let j=0; j < warehouse_y; j++) {
            ret.push(
                <Rect
                    key={nanoid()}
                    x={20 + i*80}
                    //y={konva_margin_top + (j*130)}
                    y={(max_shelf_size * 7) + j * (60 + (max_shelf_size * 7)) }
                    width={60}
                    height={60}
                    stroke="black"
                />);
        }
    }
    return ret;
    /*warehouse.forEach((shelf, index) => {
        <Rect width={50} height={50} fill="red" />
    }*/
}

const get_draw_warehouse_elements = () => {
    console.log("get_draw_warehouse_elements");
    const konva_elements = [];

    if (warehouse) {
        warehouse.forEach((shelf, index) => {
            const position_y = Math.floor(index / warehouse_x);
            const position_x = index % warehouse_x;
            // console.log(position_x, "*", position_y);
            shelf.forEach((item, item_index) => {
                konva_elements.push(
                    <Rect
                        key={nanoid()}
                        x={20 + position_x * 80 + 5 - (item_index * 1)}
                        //y={konva_margin_top + (position_y * 130 + 5) - (item_index * 7)}
                        y={(max_shelf_size * 7) + position_y * (60 + (max_shelf_size * 7)) + 5 - (item_index * 7) }
                        width={50}
                        height={50}
                        fill={colors[item.type]}
                        stroke="black"
                    />
                );
            })
        });
    }

    return konva_elements;
}


export const Warehouse2 = () => {
    // State pro sledování obsazenosti skladu
    useEffect(() => {
        warehouse = create_empty_warehouse();
    }, []);
    //const [warehouse, setWarehouse] = useState(create_empty_warehouse());
    const [outputs, setOutputs] = useState([]);
    const [log, setLog] = useState([]);

    /////////////////////////////////////////////////////////////////////
    // Basic warehouse operations
    /////////////////////////////////////////////////////////////////////

    // Umisteni noveho zbozi do skladu
    const placeItem = (item, to_shelf) => {
        if (to_shelf !== null) {
            warehouse[to_shelf].push(item);
            shelf_recalculate_prices(warehouse[to_shelf]);
            return true;
        } else {
            console.log("Error: Neni kam umistit zbozi.");
            return false;
        }
    };

    // Presun jednoho zbozi na jine misto
    const moveItem = (from_shelf, to_shelf) => {
        return new Promise(resolve => {
            let message = "";
            let message_new_line = true;
            let return_value = false;
            if (to_shelf !== null) {
                const item = warehouse[from_shelf].pop();
                if (item) {
                    shelf_recalculate_prices(warehouse[from_shelf]);
                    warehouse[to_shelf].push(item);
                    shelf_recalculate_prices(warehouse[to_shelf]);
                    message = from_shelf + ">" + to_shelf + " (typ " + item.type + ")";
                    message_new_line = false;
                    return_value = true;
                } else {
                    message = "Prazdny regal " + from_shelf + ", není co přesunout";
                    return_value = false;
                }
            } else {
                message = "Error: Neni kam presunout zbozi.";
                return_value = false;
            }
            setTimeout(() => {
                wh_log(message/*, message_new_line*/);
                draw_warehouse();
                count_of_moves += 1;
                resolve(return_value);
            }, move_time);
        })

    }

    // Vyskladneni zbozi
    const moveItemOut = (from_shelf) => {
        return new Promise(resolve => {
            const item = warehouse[from_shelf].pop();
            setTimeout(() => {
                if (item) {
                    shelf_recalculate_prices(warehouse[from_shelf]);
                    setOutputs(prevState => [...prevState, item]);
                    wh_log(from_shelf + ">out (typ " + item.type + ")");
                    draw_warehouse();
                    count_of_moves += 1;
                    count_of_outputs += 1;
                    resolve(true);
                } else {
                    wh_log("Prazdny regal, není co vyskladnit");
                    resolve(false);
                }
            }, move_time);
        })
    }


    /////////////////////////////////////////////////////////////////////
    // Log functions
    /////////////////////////////////////////////////////////////////////

    const logRef = useRef(null);
    const scrollToBottom = () => {
        logRef.current.scrollIntoView({ behavior: "smooth", block: "end" })
    }

    useEffect(() => scrollToBottom(), [log]);

    /*const wh_log = (message) => {
        setLog(prevLog => {
            const updated_log = [...prevLog];
            updated_log[updated_log.length-1] = [...updated_log[updated_log.length-1], <span key={nanoid()}>{message}, </span>];
            return(updated_log);
        });
    }

    const wh_log_nl = (message) => {
        setLog(prevLog => {
            const updated_log = [...prevLog, [<span key={nanoid()}>{message}</span>]];
            return(updated_log);
        })
    }*/
    const wh_log = (message) => {
        setLog(prevLog => {
            const updated_log = [...prevLog, <span key={nanoid()}>{message}, </span>];
            return(updated_log);
        });
    }

    const wh_log_nl = (message) => {
        setLog(prevLog => {
            const updated_log = [...prevLog, <br key={nanoid()}/>, <span key={nanoid()}>{message}</span>];
            return(updated_log);
        })
    }


    /////////////////////////////////////////////////////////////////////
    // Funkce pro náhodné umístění zboží
    /////////////////////////////////////////////////////////////////////

    const getPositionForNewItem = (forbidden_shelf=null) => {
        let best_shelf_index = null;
        let best_shelf_size = max_shelf_size;
        warehouse.forEach((shelf, index) => {
            if (index !== forbidden_shelf) {
                if (shelf.length < best_shelf_size) {
                    best_shelf_index = index;
                    best_shelf_size = shelf.length;
                }
            }
        });
        return best_shelf_index;
    }

    const placeItemRandomly = (item) => {
        // Implementujte logiku pro náhodné umístění
        const best_shelf_index = getPositionForNewItem();

        // Aktualizujte stav skladu
        if (best_shelf_index !== null) {
            placeItem(item, best_shelf_index);
        } else {
            console.log("Sklad je plný");
        }
    };



    const find_cheapest_shelf = (item_type) => {
        let best_shelf_index = null;
        let best_output_price = max_shelf_size;
        warehouse.forEach((shelf, index) => {
            const item = shelf.findLast(item => item.type === item_type);
            if (item) {
                if (item.output_price < best_output_price) {
                    best_shelf_index = index;
                    best_output_price = item.output_price;
                }
            }
        });
        return best_shelf_index;
    }

    const check_top_item_type_in_shelf = (shelf_index, item_type) => {
        return (warehouse[shelf_index][warehouse[shelf_index].length-1].type === item_type);
    }

    const outputItem = (item_type) => {
        return new Promise(resolve => {

            const from_shelf = find_cheapest_shelf(item_type);
            if (from_shelf !== null) {
                // console.log("cheapest shelf:", from_shelf);
                if (check_top_item_type_in_shelf(from_shelf, item_type)) {
                    resolve(moveItemOut(from_shelf));
                } else {
                    const to_shelf = getPositionForNewItem(from_shelf);
                    moveItem(from_shelf, to_shelf).then(result => {
                        if (result) {
                            resolve(outputItem(item_type));
                        } else {
                            console.log("Error: nelze vyskladnit");
                            wh_log("Error: nelze vyskladnit");
                            resolve(false);
                        }
                    });

                }
            } else {
                console.log("Požadované zboží není ve skladu.");
                wh_log("Požadované zboží není ve skladu (typ " + item_type + ")");
                resolve(false);
            }
        })
    }

    let count_of_moves, count_of_outputs;
    const outputItems = async (count) => {
        const expected_outputs = [];
        count_of_moves = 0;
        count_of_outputs = 0;
        setOutputs([]);
        for (let i=0; i < count; i++) {
            const item_type = Math.floor(Math.random() * max_item_types);
            expected_outputs.push(item_type);
            wh_log_nl(<strong style={{color: colors[item_type]}}>Typ {item_type}: </strong>);
            await outputItem(item_type);
            //wh_log("end (typ " + item_type + ")");
        }
        console.log("expected_outputs:", expected_outputs);
        wh_log_nl(<strong>Vyžádáno: 20, Vyskladněno: {count_of_outputs}, Počet pohybů: {count_of_moves}</strong>);
        //setTimeout(() => scrollToBottom(), 1000);
    }


    const add_random_items = (items_count) => {
        for (let i=0; i < items_count; i++) {
            const new_item = {
                id: i,
                type: Math.floor(Math.random() * max_item_types),
            }
            placeItemRandomly(new_item);
            draw_warehouse();
        }
    }


    /////////////////////////////////////////////////////////
    // Konva
    /////////////////////////////////////////////////////////

    const [warehouseDraw, setWarehouseDraw] = useState([]);
    const draw_warehouse = () => {
        const draw_elements = get_draw_warehouse_elements();
        setWarehouseDraw(draw_elements);
    }

    return (
        <div>
            {/* Vykreslete regály a zboží */}
            {/* Přidávací tlačítko pro vkládání nového zboží */}



            <Grid container spacing={2} sx={{p: 2}}>
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Paper elevation={5} sx={{p: 1, fontSize: 14}}>
                        <div>Rozměry skladu: {warehouse_x} x {warehouse_y}</div>
                        <div>Max výška regálu: {max_shelf_size}</div>
                        <div>Počet typů položek: {max_item_types}</div>
                        <div>Trvání 1 pohybu: {move_time} ms</div>
                    </Paper>
                </Grid>
                <Grid item xs={6} sm={8} md={9} lg={10} sx={{textAlign: "center"}}>

                    <Button onClick={() => add_random_items(100)}>Přidat 100 zboží</Button>
                    <Button onClick={() => outputItems(20)}>Vyskladnit 20 položek</Button>
                    <Button onClick={() => draw_warehouse()}>Vykreslit sklad</Button>
                    |
                    <Button onClick={() => moveItem(0,4)} size="small">Move Item (0)</Button>
                    <Button onClick={() => {
                        wh_log_nl(<strong style={{color: colors[5]}}>Typ 5: </strong>);
                        outputItem(5);
                    }} size="small">Output item (type 5)</Button>
                    <Button onClick={() => {
                        wh_log_nl(<strong style={{color: colors[15]}}>Typ 15: </strong>);
                        outputItem(15);
                    }} size="small">Output item (type 15)</Button>
                    |
                    <Button onClick={() => console.log("warehouse:", warehouse)} size="small">Vypsat sklad</Button>
                    <Button onClick={() => console.log("outputs:", outputs.map(o => o.type))} size="small">Vypsat výstupy</Button>
                    |
                    <Button onClick={() => {
                        warehouse = create_empty_warehouse();
                        draw_warehouse();
                    }} color="error" size="small">Vyprázdnit sklad</Button>
                    <Button onClick={() => setLog([])} color="error" size="small">Vymazat log</Button>
                    <Button onClick={() => setOutputs([])} color="error" size="small">Vymazat výstupy</Button>

                </Grid>
                <Grid item md={6} sm={12}>
                    <Paper elevation={5}  sx={{height: 500, p: 1}}>
                        <Stage width={600} height={600}>
                            <Layer>
                                {draw_warehouse_basic()}
                            </Layer>
                            <Layer>
                                {warehouseDraw}
                            </Layer>
                            <Layer>
                                {outputs.map((item, index) =>
                                    <Rect
                                        key={item.id}
                                        x={10 + index * 7}
                                        //y={konva_margin_top + (warehouse_y * 130) - 30}
                                        y={40 + warehouse_y * (60 + (max_shelf_size * 7)) }
                                        width={50}
                                        height={50}
                                        fill={colors[item.type]}
                                        stroke="black"
                                    />
                                )}
                            </Layer>
                        </Stage>
                    </Paper>
                </Grid>
                <Grid item md={6} sm={12}>
                    <Paper elevation={5} sx={{height: 500, p: 1, overflowY: "scroll"}}>
                        <Box ref={logRef} sx={{pb: 1}}>
                            {/*log.map((line, index) => <div key={index}>{line}</div>)*/}
                            {log}
                        </Box>
                    </Paper>
                </Grid>

            </Grid>
        </div>
    );
};
